<template>
  <v-navigation-drawer
    fixed
    color="primary"
    class="elevation-8"
    :width="getNavigationDrawerWidth"
    v-if="showNavigationDrawer"
    app
  >
    <v-list-item class="pl-4">
      <v-img src="@/assets/img/policia.png" contain class="mb-1"></v-img>
    </v-list-item>
    <v-divider></v-divider>
    <v-list v-if="muestraMenuProfesionalizacion">
      <v-list-item>
        <IconButton class="mr-3" icon="mdi-home" to="/profesionalizacion/dashboard" />
      </v-list-item>
      <v-list-item v-if="hasAccessToFeature(perfil, FEATURES.CANDIDATOS)">
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <IconButton
              icon="mdi-account-edit"
              class="mr-3"
              to="/profesionalizacion/candidatos"
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <span>Candidatos</span>
        </v-tooltip>
      </v-list-item>
      <v-list-item v-if="hasAccessToFeature(perfil, FEATURES.CONTROL_ASPIRANTES)">
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <IconButton
              icon="mdi-account-group"
              class="mr-3"
              to="/profesionalizacion/preaspirantes"
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <span>Control de aspirantes</span>
        </v-tooltip>
      </v-list-item>
      <v-list-item>
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <IconButton
              icon="mdi-shield-account"
              class="mr-3"
              to="/profesionalizacion/personal"
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <span>Personal</span>
        </v-tooltip>
      </v-list-item>

      <v-list-item v-if="hasAccessToFeature(perfil, FEATURES.CAPACITADORES)">
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <IconButton
              icon="mdi-school"
              class="mr-3"
              to="/profesionalizacion/capacitadores"
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <span>Capacitadores</span>
        </v-tooltip>
      </v-list-item>
      <v-list-item v-if="hasAccessToFeature(perfil, FEATURES.CURSOS)">
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <IconButton
              icon="mdi-cast-education"
              class="mr-3"
              to="/profesionalizacion/cursos"
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <span>Capacitación</span>
        </v-tooltip>
      </v-list-item>
      <v-list-item v-if="hasAccessToFeature(perfil, FEATURES.CURSOS_PROGRAMADOS)">
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <IconButton
              icon="mdi-calendar"
              class="mr-3"
              to="/profesionalizacion/cursos_programados"
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <span>Capacitaciones Programadas</span>
        </v-tooltip>
      </v-list-item>
      <v-list-item v-if="hasAccessToFeature(perfil, FEATURES.SUGERENCIA_CURSOS)">
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <IconButton
              icon="mdi-comment-quote"
              class="mr-3"
              to="/profesionalizacion/solicitud_cursos"
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <span>Sugerencias de capacitaciones</span>
        </v-tooltip>
      </v-list-item>
    </v-list>
    <v-list v-if="muestraMenuPersonal">
      <v-list-item>
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <IconButton icon="mdi-home" class="mr-3" to="/personal/dashboard" v-bind="attrs" v-on="on" />
          </template>
          <span>Home</span>
        </v-tooltip>
      </v-list-item>
      <v-list-item>
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <IconButton icon="mdi-account-group" class="mr-3" to="/personal/preaspirantes" v-bind="attrs" v-on="on" />
          </template>
          <span>Aspirantes pendientes de consulta previa</span>
        </v-tooltip>
      </v-list-item>
      <v-list-item>
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <IconButton
              icon="mdi-account-multiple-check"
              class="mr-3"
              to="/personal/aspirantes"
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <span>Aspirantes pendientes de registro de CUIP</span>
        </v-tooltip>
      </v-list-item>
      <v-list-item>
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <IconButton icon="mdi-shield-account" class="mr-3" to="/personal/personal" v-bind="attrs" v-on="on" />
          </template>
          <span>Personal</span>
        </v-tooltip>
      </v-list-item>
    </v-list>
    <v-list v-if="muestraMenuEnlace">
      <v-list-item>
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <IconButton icon="mdi-home" class="mr-3" to="/enlace_c3/dashboard" v-bind="attrs" v-on="on" />
          </template>
          <span>Home</span>
        </v-tooltip>
      </v-list-item>
      <v-list-item>
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <IconButton icon="mdi-account-alert" class="mr-3" to="/enlace_c3/aspirantes" v-bind="attrs" v-on="on" />
          </template>
          <span>Aspirantes</span>
        </v-tooltip>
      </v-list-item>
      <v-list-item>
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <IconButton icon="mdi-shield-account" class="mr-3" to="/enlace_c3/personal" v-bind="attrs" v-on="on" />
          </template>
          <span>Personal</span>
        </v-tooltip>
      </v-list-item>

      <v-list-item>
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <IconButton
              icon="mdi-account-box-outline"
              class="mr-3"
              to="/enlace_c3/nuevos-ingresos"
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <span>Nuevos Ingresos</span>
        </v-tooltip>
      </v-list-item>
      <!--proceso evaluacion fin-->
    </v-list>
    <v-list v-if="muestraMenuRH">
      <v-list-item>
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <IconButton icon="mdi-home" class="mr-3" to="/recursos_humanos/dashboard" v-bind="attrs" v-on="on" />
          </template>
          <span>Inicio</span>
        </v-tooltip>
      </v-list-item>
      <v-list-item>
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <IconButton
              icon="mdi-shield-account"
              class="mr-3"
              to="/recursos_humanos/personal"
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <span>Personal</span>
        </v-tooltip>
      </v-list-item>
    </v-list>
    <ArmeriaNavigationDrawerList />
    <v-list v-if="muestraMenuEquipamiento">
      <v-list-item>
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <IconButton icon="mdi-shield-account" class="mr-3" to="/equipamiento/personal" v-bind="attrs" v-on="on" />
          </template>
          <span>Personal</span>
        </v-tooltip>
      </v-list-item>
      <v-list-item>
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <IconButton icon="mdi-briefcase-variant" class="mr-3" to="/equipamiento/items" v-bind="attrs" v-on="on" />
          </template>
          <span>Catálogo de items</span>
        </v-tooltip>
      </v-list-item>
      <v-list-item>
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <IconButton icon="mdi-briefcase-variant" class="mr-3" to="/equipamiento/equipo" v-bind="attrs" v-on="on" />
          </template>
          <span>Control de equipo</span>
        </v-tooltip>
      </v-list-item>
    </v-list>
    <v-list v-if="muestraMenuDesarrolloProfesional">
      <v-list-item>
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <IconButton icon="mdi-home" class="mr-3" to="/desarrollo_profesional/dashboard" v-bind="attrs" v-on="on" />
          </template>
          <span>Inicio</span>
        </v-tooltip>
      </v-list-item>
      <v-list-item>
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <IconButton
              icon="mdi-shield-account"
              class="mr-3"
              to="/desarrollo_profesional/personal"
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <span>Personal</span>
        </v-tooltip>
      </v-list-item>
      <v-list-item v-if="hasAccessToFeature(perfil, FEATURES.CONVOCATORIAS)">
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <IconButton
              icon="mdi-file-certificate"
              class="mr-3"
              to="/desarrollo_profesional/convocatorias"
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <span>Convocatorias</span>
        </v-tooltip>
      </v-list-item>
      <v-list-item>
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <IconButton
              icon="mdi-account-check-outline"
              class="mr-3"
              to="/desarrollo_profesional/nuevos_ingresos"
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <span>Nuevos ingresos</span>
        </v-tooltip>
      </v-list-item>
    </v-list>
    <v-list v-if="muestraMenuEnlaceNuevo">
      <v-list-item class="d-flex justify-center">
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <IconButton
              icon="mdi-shield-account"
              class="menu-button primary--text"
              to="/enlace/pase_lista"
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <span>Personal Asignado</span>
        </v-tooltip>
      </v-list-item>
      <v-list-item class="d-flex justify-center">
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <IconButton
              icon="mdi-clipboard-check-multiple-outline"
              class="menu-button primary--text"
              to="/enlace/pase_lista_masivo"
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <span>Pase de lista masivo</span>
        </v-tooltip>
      </v-list-item>
      <v-list-item class="d-flex justify-center">
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <IconButton
              icon="mdi-bell-alert"
              class="menu-button primary--text"
              to="/enlace/novedades"
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <span>Novedades</span>
        </v-tooltip>
      </v-list-item>
    </v-list>
    <template v-slot:append>
      <div class="d-flex flex-column align-center">
        <v-list>
          <!-- Toggle de tema oscuro eliminado - tema oscuro es permanente -->
          <!-- <v-list-item>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <IconButton
                  class="menu-button primary--text"
                  :icon="$vuetify.theme.dark ? 'mdi-brightness-6' : 'mdi-brightness-4'"
                  v-bind="attrs"
                  v-on="on"
                  @click="$vuetify.theme.dark = !$vuetify.theme.dark"
                />
              </template>
              <span v-if="$vuetify.theme.dark">Cambiar a modo oscuro</span>
              <span v-else>Cambiar a modo claro</span>
            </v-tooltip>
          </v-list-item> -->
          <v-list-item>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <IconButton
                  class="menu-button primary--text"
                  icon="mdi-face-agent"
                  v-bind="attrs"
                  v-on="on"
                  @click="openUrl('https://soporte.socom.mx')"
                />
              </template>
              <span>Soporte técnico</span>
            </v-tooltip>
          </v-list-item>
          <v-list-item>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <IconButton
                  class="menu-button primary--text"
                  icon="mdi-information"
                  v-bind="attrs"
                  v-on="on"
                  v-on:click="versionDialog = true"
                />
              </template>
              <span>Acerca de</span>
            </v-tooltip>
          </v-list-item>
          <v-list-item v-if="hasAccessToFeature(perfil, FEATURES.SALIR_APLICACION)">
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <IconButton
                  class="menu-button primary--text"
                  icon="mdi-exit-to-app"
                  v-bind="attrs"
                  v-on="on"
                  to="/launcher"
                />
              </template>
              <span>Salir de la aplicación</span>
            </v-tooltip>
          </v-list-item>
        </v-list>
      </div>
    </template>
    <version-dialog-component :active="versionDialog" @close="versionDialog = false"></version-dialog-component>
  </v-navigation-drawer>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import VersionDialogComponent from './VersionDialogComponent.vue'
import IconButton from './base/IconButton.vue'
import ArmeriaNavigationDrawerList from './navigation-drawer-lists/ArmeriaNavigationDrawerList.vue'

export default {
  components: {
    VersionDialogComponent,
    IconButton,
    ArmeriaNavigationDrawerList,
  },

  data() {
    return {
      versionDialog: false,
    }
  },

  computed: {
    ...mapGetters({
      loading: 'getLoader',
      token: 'getToken',
      perfil: 'getPerfil',
    }),

    getNavigationDrawerWidth: function () {
      if (this.loading) {
        return 0
      } else {
        return 64
      }
    },

    showNavigationDrawer: function () {
      if (
        this.token.length == 0 ||
        this.$route.name == 'Registro de preaspirante' ||
        this.$route.name == 'Login' ||
        this.$route.name == 'Launcher'
      ) {
        return false
      } else return true
    },

    muestraMenuPreaspirantes: function () {
      if (this.$route.matched.some(({ path }) => path === '/candidato')) {
        return true
      } else return false
    },

    muestraMenuProfesionalizacion: function () {
      if (this.$route.matched.some(({ path }) => path === '/profesionalizacion')) {
        return true
      } else return false
    },

    muestraMenuPersonal: function () {
      if (this.$route.matched.some(({ path }) => path === '/personal')) {
        return true
      } else return false
    },

    muestraMenuArmeria: function () {
      if (this.$route.matched.some(({ path }) => path === '/armeria')) {
        return true
      } else return false
    },

    muestraMenuRH: function () {
      if (this.$route.matched.some(({ path }) => path === '/recursos_humanos')) {
        return true
      } else return false
    },

    muestraMenuEquipamiento: function () {
      if (this.$route.matched.some(({ path }) => path === '/equipamiento')) {
        return true
      } else return false
    },

    muestraMenuDesarrolloProfesional: function () {
      if (this.$route.matched.some(({ path }) => path === '/desarrollo_profesional')) {
        return true
      } else return false
    },

    muestraMenuEnlace: function () {
      if (this.$route.matched.some(({ path }) => path === '/enlace_c3')) {
        return true
      } else return false
    },
    muestraMenuEnlaceNuevo: function () {
      return this.$route.matched.some(({ path }) => path === '/enlace')
    },
  },

  methods: {
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),

    mergeAttrs(...sources) {
      return Object.assign({}, ...sources)
    },

    mergeOn(...sources) {
      return Object.assign({}, ...sources)
    },

    triggerLogout: function () {
      this.SET_SNACKBAR_MESSAGE('Cerrando sesión...')
      this.logout()
      window.location.reload()
      // this.$router.replace('/')
    },

    openUrl(url) {
      window.open(url, '_blank')
    },
  },
}
</script>
<style scoped>
.inventario-enlace {
  background-color: #e3f2fd !important;
}
.inventario-armeria {
  background-color: #fff3e0 !important;
}
</style>
